import { OptionType } from '~/features/types';
import { specialtiesToOptions } from '~/features/vault/aoi/utils';
import { JobListing } from '~/types/hlx/jobListing';
import { getData } from '~/utils/service';
import { subspecialtiesToOptions, subspecialtyFieldsToApi } from '../../../subspecialties';
import { BasicInfoFormValues } from './types';

export const loadAOIOptionByProviderCategory = async (
  providerCategoryId: number,
  searchTerm?: string
): Promise<OptionType[]> => {
  if (!providerCategoryId) {
    return [];
  }
  return await getData<OptionType[]>('aoisOptionsByProviderCategory', {
    pathParams: { providerCategoryId: providerCategoryId.toString() },
    params: { specialty_name: searchTerm },
    transformResponse: specialtiesToOptions,
  });
};

export const transformBasicInfoFormToApi = (formData: BasicInfoFormValues): string => {
  return JSON.stringify({
    jobTitle: formData.jobTitle,
    jobDescription: formData.jobDescription,
    providerCategoryId: formData.providerCategory.value,
    specialtyName: formData.aoiSpecialty.label,
    aoiSpecialtyId:
      formData.aoiSpecialty.value.trim() === '' ? null : Number(formData.aoiSpecialty.value),
    ...subspecialtyFieldsToApi(formData.subspecialties, formData.generalSpecialtyFlag),
    jobType: formData.jobType.value,
    employmentClassification: formData.employmentClassification.value,
    workLocation: formData.workLocation.value,
  } as Omit<
    JobListing,
    | 'id'
    | 'employer'
    | 'facilities'
    | 'details'
    | 'negotiations'
    | 'employerId'
    | 'primaryFacility'
    | 'stateCodes'
    | 'subspecialties'
  > &
    ReturnType<typeof subspecialtyFieldsToApi>);
};

export const transformApiToBasicInfoForm = (apiData: JobListing): BasicInfoFormValues => {
  return {
    id: apiData.id,
    jobTitle: apiData.jobTitle,
    jobDescription: apiData.jobDescription || '',
    providerCategory: { label: '', value: apiData.providerCategoryId },
    aoiSpecialty:
      apiData.aoiSpecialtyId && apiData.specialtyName
        ? { label: apiData.specialtyName, value: apiData.aoiSpecialtyId.toString() }
        : { label: '', value: '' },
    subspecialties: subspecialtiesToOptions(apiData.subspecialties),
    generalSpecialtyFlag: apiData.generalSpecialtyFlag ?? true,
    jobType: { label: apiData.jobType, value: apiData.jobType },
    employmentClassification: {
      label: apiData.employmentClassification || '',
      value: apiData.employmentClassification || '',
    },
    workLocation: {
      label: apiData.workLocation.charAt(0) + apiData.workLocation.slice(1).toLowerCase(),
      value: apiData.workLocation,
    },
  };
};
